import { createTheme, ThemeOptions } from '@mui/material/styles'
import { outlinedInputClasses } from '@mui/material'
import { themeOptions as themeOptionsAer } from './aer'
import merge from 'lodash/merge'

const getThemeOptions = (themeName: string): ThemeOptions => {
    switch (themeName) {
        case 'aer':
            return themeOptionsAer
    }
    return {}
}

export const getTheme = (themeName?: string, shadowRootElement?: HTMLElement) => {
    const themeOptions = themeName ? getThemeOptions(themeName) : {}
    const shadowDomOptions = shadowRootElement ? {
        components: {
            MuiPopover: {
                defaultProps: {
                    container: shadowRootElement
                }
            },
            MuiPopper: {
                defaultProps: {
                    container: shadowRootElement
                }
            },
            MuiModal: {
                defaultProps: {
                    container: shadowRootElement
                }
            }
        }
    } : {}
    const specialTheme = createTheme(themeOptions)
    return createTheme(
        merge(
            {
                palette: {
                    cta: {
                        light: '#ffff66',
                        main: '#fecd2f',
                        dark: '#c79c00',
                        contrastText: '#000',
                    },
                },
                shape: {
                    borderRadius: 0,
                },
                typography: {
                    fontFamily: '"Open Sans", sans-serif',
                    h1: {
                        fontWeight: 'normal',
                        fontSize: 26,
                        color: '#313c45',
                    },
                    h2: {
                        fontWeight: 'normal',
                        fontSize: 20,
                        color: '#313c45',
                    },
                    h3: {
                        fontWeight: 'normal',
                        fontSize: 18,
                        color: '#313c45',
                    },
                    body1: {
                        fontSize: 14,
                        color: '#313c45',
                    },
                },
                components: {
                    MuiTypography: {
                        styleOverrides: {
                            gutterBottom: {
                                marginBottom: specialTheme.spacing(2),
                            },
                        },
                    },
                    MuiButton: {
                        defaultProps: {
                            variant: 'contained',
                            size: 'large',
                            color: 'primary',
                            disableElevation: false,
                        },
                        styleOverrides: {
                            root: {
                                borderRadius: 3,
                                textTransform: 'initial',
                            },
                        },

                    },
                    MuiOutlinedInput: {
                        styleOverrides: {
                            root: {
                                [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                    borderWidth: 1,
                                    borderBottomWidth: 2,
                                    borderBottomColor: specialTheme.palette.primary.main,
                                },
                            },
                        },
                    },
                }
            },
            themeOptions,
            shadowDomOptions
        )
    )
}

declare module '@mui/material/styles' {
    interface Palette {
        cta: Palette['primary']
    }

    interface PaletteOptions {
        cta?: PaletteOptions['primary']
    }
}

// Update the Button's color prop options
declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        cta: true
    }
}
